<template>
    <div class="history-point m-auto" data-cy="container_history_point">
        <div class="w-3/4 mx-auto" data-cy="container_history_point_month_picker">
            <MonthPickerDropdown
                v-model:inputValue="monthSelect"
                data-cy="input_history_point_month_picker"
                :inputLbl="lbl.history.monthPicker"
                @update:inputValue="onMonthSelect()"
                @onClick="onTracking($event)"
            ></MonthPickerDropdown>
        </div>
        <div v-show="historyList.length > 0 && isLoaded" data-cy="list_history_point">
            <HistoryPointItem
                    v-for="(v, index) in historyList"
                    :key="v.rowKey"
                    :data-cy="`container_history_point_item_${index}`"
                    :pointItem="v"
            ></HistoryPointItem>
        </div>
        <div v-show="historyList.length == 0 && isLoaded" data-cy="container_history_point_empty">
            <Nodata
                :textData="lbl.no_data"
                :isTextOnly="true" />
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
//component
import MonthPickerDropdown from '@/components/Input/label/MonthPickerDropdown.vue';
import HistoryPointItem from './HistoryPointItem.vue';
import Nodata from '@/components/Layout/Page/NoData.vue';
//service
import BzbsPoint from '@/core/Point/service/BzbsPoint.js';
import { HistoryPointConfigBuilder } from '@/core/Point/config/PointConfigModel.js'

export default {
    name: 'HistoryPoint',
    mixins: [LocaleMixin, ModalMixin],
    components: {
        MonthPickerDropdown,
        HistoryPointItem,
        Nodata,
    },
    data: function() {
        return {
            monthSelect: new Date(),
            historyList: [],
            isLoaded: false,
        };
    },
    methods: {
        onTracking: function(data){
            if(!data) return;

            let tracking_category = '';
            let tracking_action = '';

            switch (data){
                case 'month':
                    tracking_category = 'history_point';
                    tracking_action = 'click_month';
                    break;
                case 'year':
                    tracking_category = 'history_point';
                    tracking_action = 'click_year';
                    break;
            }

            this.tracking.event(tracking_category, tracking_action, null, null);
        },
        onMonthSelect: async function() {
            Util.log('select month', this.monthSelect);

            let configParams = new HistoryPointConfigBuilder()
                    .setMonth(this.monthSelect)
                    .create()
                    .getParams();
            await this.getHistoryPoint(configParams);
        },
        getHistoryPoint: function(configParams) {
            return new Promise((resolve) => {
                BzbsPoint.apiGetPointHistory(configParams).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.historyList = data;
                        this.isLoaded = true;

                        resolve();
                    },
                    error: (err) => {
                        if(err.id == 401){
                            this.$router.push('/error');
                        }else{
                            this.errorApi(err);
                        }

                        resolve(null);
                    },
                })
            })
            
        },
    },
}
</script>
<style lang="scss" scoped>
    .history-point {
        max-width: 500px;
    }
</style>
